var map = {
	"./bh-ico.svg": 794,
	"./bonus-ico.svg": 795,
	"./deposit-ico.svg": 796,
	"./edit-icon.svg": 797,
	"./fb-ico.svg": 798,
	"./instant-rebate-ico.svg": 799,
	"./mall-ico.svg": 800,
	"./msg-ico.svg": 801,
	"./pi-ico.svg": 802,
	"./rf-ico.svg": 803,
	"./rh-ico.svg": 804,
	"./th-ico.svg": 805,
	"./vip-ico.svg": 806,
	"./withdrawal-ico.svg": 807,
	"./wl-ico.svg": 808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2086;